/* eslint-disable react-hooks/exhaustive-deps */
/*
 * @Author: changcheng
 * @LastEditTime: 2022-12-30 14:37:02
 */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthMenuData } from "@root/common/service";
import type { MenuProps } from "antd";
import { Menu, Row, Col } from "antd";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import "./_index.scss";
export const RouterAuthorizan = () => {
  const navigate = useNavigate();
  const [menuKey, setMenuKey] = useState("");
  const [menu, setMenu] = useState([]);
  const { baseUserCategory, access_token } = useSelector(
    (state: RootState) => state.userInfo
  );
  const formatMenuData = (menuData: any) => {
    let menu = menuData.map((item: any) => {
      const { path, name, meta, alwaysShow } = item;
      if (path === "/") {
        const { component, path, meta } = item.children[0];
        return {
          label: meta.title,
          key: path,
          component: alwaysShow === true ? null : component,
          children: null,
        };
      } else {
        return {
          label: meta.title,
          key: name,
          component: alwaysShow === true ? null : name,
          children: item.children ? formatMenuData(item.children) : null,
        };
      }
    });

    return menu;
  };
  const queryAuthMenuData = async () => {
    const { data } = await getAuthMenuData();

    const menuData = formatMenuData(data[baseUserCategory as string]);
    setMenu(menuData);

    const key = menuData[0].component
      ? menuData[0].key
      : menuData[0].children[0].key;
    setMenuKey(key);
    navigate(`/home/userCenter/${key}`);
  };

  useEffect(() => {
    access_token && queryAuthMenuData();
  }, [baseUserCategory]);
  const onClick: MenuProps["onClick"] = (e) => {
    const { key } = e;
    setMenuKey(key);
    navigate(`/home/userCenter/${key}`);
  };
  return (
    <div className="routerContainer">
      <Row className="routerContainer-wrapper">
        <Col xs={24} sm={24} md={6} lg={6} xl={5} xxl={4}>
          <Menu
            items={menu}
            mode="inline"
            onClick={onClick}
            className="menu"
            selectedKeys={[menuKey]}
          ></Menu>
        </Col>
        <Col
          xs={24}
          md={18}
          lg={18}
          xl={19}
          xxl={20}
          style={{
            padding: "10px",
          }}
        >
          <Outlet />
        </Col>
      </Row>
    </div>
  );
};
